import React from 'react'
import styled from 'styled-components'

const Wrapper = styled.div`
  text-align: center;
  cursor: pointer;
  width: 150px;

  @media screen and (max-width: 768px) {
    width: 80px;
  }

`

const CenteredBox = styled.div`
  border: 1px solid #DEDEDE;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all .3s ease;
  height: 80px;
  width: 80px;
  margin: 0 auto;

  &:hover,
  &.selected {
    background: linear-gradient(270deg, #006736 0%, #93C13E 100%);

    svg path {
      fill: #fff;
    }
  }

  @media screen and (max-width: 768px) {
    width: 55px;
    height: 55px;
  }
`

const Title = styled.span`
  display: block;
  text-transform: uppercase;
  margin-top: 20px;
  font-size: 12px;
  line-height: 12px;
  color: #010101;
  font-weight: bold;
  text-align: center;
  font-family: 'Nunito', 'Helvetica Neue', sans-serif;
`

const FilterBox = ({ icon, name, selected, onClick, className }) => (
  <Wrapper onClick={onClick} className={className}>
    <CenteredBox className={selected && 'selected'}>
      {icon}
    </CenteredBox>
    <Title>{name}</Title>
  </Wrapper>
)

export default FilterBox



// WEBPACK FOOTER //
// ./src/components/FilterBox/index.js